import * as React from 'react';
import { ButtonModifier } from '../../../infrastructure/helpers';
import DefaultButton from '../default-button/default-button';
import classnames from 'classnames';
import { IMultiSelectClosedPropsDerivedFromItemsList } from './make-multi-select-in-popover';
import { makeOrganizationMultiSelect } from './make-organization-multi-select';

type IMultiSelectButtonProps = IMultiSelectClosedPropsDerivedFromItemsList & { text: string; className?: string; onClick?: () => void };

/**
 * Render DefaultButton, with label, selectable through the SingleSelectList rendered in popover
 * change button look and feel based on popover being shown/hidden
 */
const OrganizationMultiSelectButton = makeOrganizationMultiSelect(
  React.forwardRef((props: IMultiSelectButtonProps, ref: React.Ref<HTMLInputElement>) => {
    const { text, isOpen, onClick, className } = props;
    const modifiers: ButtonModifier[] = ['fat'];
    if (isOpen) {
      modifiers.push('confirm-safe');
    } else {
      modifiers.push('options');
    }

    return <DefaultButton
      modifier={modifiers}
      text={text}
      ref={ref}
      onClick={() => isOpen && onClick && onClick()}
      className={classnames(className, {
      'active': isOpen
    })} />;
  })
);

export { OrganizationMultiSelectButton, IMultiSelectButtonProps };
